/**
 * Character background image component for IA Corner displays.
 * Displays the background image for character cards with rounded corners and fixed dimensions.
 */

import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import Screen from '../../../../shared/utils/screen';

/**
 * Styled character background image with absolute positioning and rounded corners.
 */
const CharacterBackground = styled.img<React.CSSProperties>`
  border-radius: ${16 * Screen.widthRatio}px;
  height: ${200 * Screen.widthRatio}px;
  width: ${200 * Screen.widthRatio}px;
  position: absolute;
`;

export default withImage(CharacterBackground, false);
